<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sd/ba"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
    >
      <template slot="otherBtn">
        <el-upload
            style="float: left"
            action=""
            :http-request="importFile"
            :disabled="importLoading"
            :show-file-list="false">
          <el-button v-if="limits.importAuth" style="margin-left: 10px" :loading="importLoading" type="primary">导入
          </el-button>
        </el-upload>
      </template>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="商务编号">
              <el-input v-model.trim="filter.businessApplicationNO" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model.trim="filter.statusName" placeholder="请选择" clearable>
                <el-option label="草稿" value="草稿"/>
                <el-option label="业务经理审核" value="销售区总审核"/>
                <el-option label="财务经理审核" value="销售总监审核"/>
                <el-option label="总经理审批" value="总经理审批"/>
                <el-option label="通过" value="通过"/>
                <el-option label="退回" value="退回"/>
              </el-select>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button type="primary" :loading="submitLoading" :disabled="scope.row.status !== 2201"
                   @click="submitHandle(scope.row)">提交
        </el-button>
        <el-button type="primary" :disabled="scope.row.status !== 2203" @click="copyHandle(scope.row)">复制</el-button>
      </template>
    </view-table>
    <business-application-edit ref="businessApplicationEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import BusinessApplicationEdit from "./BusinessApplicationEdit";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "BusinessApplicationList",
    components: {ViewTable, BusinessApplicationEdit},
    data() {
      return {
        limits: {
          addAuth: this.$auth(305),
          editAuth: this.$auth(302),
          delAuth: this.$auth(303),
          importAuth: this.$auth(379),
        },
        importLoading: false,
        submitLoading: false,
        filter: {
          businessApplicationNO: "",
          customerName: "",
          statusName: "",
          materialNo: "",
          materialName: "",
          specification: "",
        },
        columnsProperty: [
          {
            key: "businessApplicationNO",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$router.push({
                          path: "/businessApplication",
                          query: {
                            billType: 3,
                            billId: params.row.billID,
                            businessApplicationID: params.row.businessApplicationID,
                            $tabName: "商务申请预览" + params.row.businessApplicationNO,
                          },
                        });
                      },
                    },
                  },
                  params.row.businessApplicationNO,
              );
            },
          },
          {
            key: "customerName",
            width: 260,
          },
          {
            key: "contact",
            align: "center",
            width: 90,
          },
          {
            key: "mobile",
            align: "center",
            width: 140,
          },
          {
            key: "statusName",
            width: 220,
          },
          {
            key: "timeLimit",
            align: "center",
            width: 110,
            render: (h, params) => {
              if (params.row.timeLimit === 20) {
                return h("span", "自定义期限");
              } else if (params.row.timeLimit === 10) {
                return h("span", "一次有效");
              } else {
                return h("span", "永久有效");
              }
            },
          },
          {
            key: "beginDate",
            align: "center",
            width: 160,
          },
          {
            key: "endDate",
            align: "center",
            width: 160,
          },
          {
            key: "paymentTypeName",
            width: 180,
          },
          {
            key: "reason",
            width: 160,
            ellipsis: true,
          },
          {
            key: "submitTime",
            align: "center",
            width: 160,
          },
          {
            key: "creatorName",
            align: "center",
            width: 90,
          },
          {
            key: "createdDate",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            align: "center",
            width: 240,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.businessApplicationEdit.open(row);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "sd/ba", row.businessApplicationID).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // 提交
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `sd/ba/submit/${row.businessApplicationID}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            }
          });
        });
      },

      // 复制(只能复制状态为通过的数据)
      copyHandle(row) {
        this.$refs.businessApplicationEdit.open(row, 1);
      },
      importFile(params) {
        this.importLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
            .post("basic", "sd/ba/batchImport", formData)
            .then((res) => {
              if (res.success) {
                this.$message.success("上传成功");
              }
              this.importLoading = false;
            })
            .catch(() => {
              this.importLoading = false;
            });
      },
      // 只能编辑和删除未提交的数据
      otherAuth(row) {
        if (row.status === 2201) {
          return {
            editAuth: false,
            delAuth: false,
          };
        } else {
          return {
            editAuth: true,
            delAuth: true,
          };
        }
      },
    },
  };
</script>
